import { useSelector } from 'react-redux'
import props from '../../../../../redux/props'
import Title from '../Title'
import { NAWSurvey } from '../../../../../types/NAW/Survey'
import { Update } from '../../../../hooks/NAW/useNAWSurveyAnswer/useNAWSurveyAnswer'
import RangeWithLabelAndDescription from '../../Elements/RangeWithLabelAndDescription'
import getCollaborationValue from './getCollaborationValue'
import { ContentWrapper } from '../PageList'
import getHomeofficeLabel from './getHomeofficeLabel'

type Props = {
  survey: NAWSurvey
  update: Update
}

const Arbeitsplaetze: React.FC<Props> = ({ survey, update }) => {
  const t = useSelector((s) => s[props.TRANSLATION])

  return (
    <ContentWrapper>
      <div className="flex flex-col h-full gap-12 md:gap-24">
        <Title text={t.naw.survey.answer.arbeitsplaetze.title} />
        <div className="flex flex-col gap-16 pb-16 md:pb-0 md:gap-24">
          <RangeWithLabelAndDescription
            value={survey.mitarbeiter}
            onChange={update('mitarbeiter')}
            label={t.naw.survey.answer.arbeitsplaetze.mitarbeiter}
            {...t.naw.survey.configuration.mitarbeiter}
          />
          <RangeWithLabelAndDescription
            value={survey.homeoffice}
            onChange={update('homeoffice')}
            label={t.naw.survey.answer.arbeitsplaetze.homeoffice}
            customCurrentValueLabel={getHomeofficeLabel(survey.homeoffice)}
            {...t.naw.survey.configuration.homeoffice}
          />
          <RangeWithLabelAndDescription
            value={survey.collaborationPercentage}
            onChange={update('collaborationPercentage')}
            label={t.naw.survey.answer.arbeitsplaetze.collaborationPercentage}
            customCurrentValueLabel={getCollaborationValue(survey.collaborationPercentage)}
            {...t.naw.survey.configuration.collaborationPercentage}
          />
        </div>
      </div>
    </ContentWrapper>
  )
}

export default Arbeitsplaetze
